import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useSiteSettings } from "../lib/siteSettings";
import { initAnalytics, track } from "../lib/analytics";
import { useLocale } from "../i18n";

// GA4 page views on every route change + Search Console verification meta (both from admin Settings).
export const SiteMeta = () => {
  const s = useSiteSettings();
  const lang = useLocale();
  const { pathname, search } = useLocation();
  const id = s.ga4_measurement_id;

  useEffect(() => {
    if (!id) return;
    initAnalytics(id);
    const t = setTimeout(() => track("page_view", { page_path: pathname + search, page_location: window.location.href, page_title: document.title, language: lang }), 800); // after Helmet has set the page title
    return () => clearTimeout(t);
  }, [id, pathname, search, lang]);

  return s.google_site_verification ? (
    <Helmet><meta name="google-site-verification" content={s.google_site_verification} /></Helmet>
  ) : null;
};
